<div class="auth-container" *ngIf="_authService.showAuth">
  <div class="left">
    <div class="logo">
      <img src="assets/img/LogoSURA.svg" alt="" width="130" />
    </div>
    <div class="form-container">
      <div class="form">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  <!-- [ngStyle]="{background: 'url(/img/' + item.img + ')', width: '200px', height: '150px'" -->
  <div class="right" [ngStyle]="{ background: 'url(' + backgroundImage + ') no-repeat center center / cover' }"></div>
</div>

<app-aviso-privacidad *ngIf="!_authService.showAuth && _authService.autoStart === true" [autoStart]="_authService.autoStart" [appToGo]="'bienestar'" (action)="manageAction($event)"></app-aviso-privacidad>
